module.exports = __webpack_public_path__ + "img/item-4(1920)new.b52ee2c6.jpg";